<template>
  <v-footer color="#fafafa" padless>
    <v-card class="flex" flat tile>
      <v-card-text class="py-2 text-right">
        <strong>Sustaine&trade; {{ version }} &copy;{{ new Date().getFullYear() }}</strong>
      </v-card-text>
    </v-card>
  </v-footer>    
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "AppFooter",
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      username: '',
      roles: ''
    }
  },
  computed: {
    ...mapGetters(['getAccount', 'hasAccess'])
  },
  created() {
    this.username = this.getAccount.username
    this.roles = this.getAccount.roles.toString()
  }
}
</script>
